import { useEffect, useRef } from 'react';
import { Toast } from '@/components/ui/toast';
import { useCartStore } from '@/features/cart/stores/cart-store';

export function CartFeedbackToast() {
  const lastAddedItem = useCartStore((state) => state.lastAddedItem);
  const clearAddFeedback = useCartStore((state) => state.clearAddFeedback);
  const shownAtRef = useRef<string | null>(null);

  useEffect(() => {
    if (!lastAddedItem) {
      shownAtRef.current = null;
      return;
    }

    if (shownAtRef.current === lastAddedItem.addedAt) {
      return;
    }

    shownAtRef.current = lastAddedItem.addedAt;
  }, [lastAddedItem]);

  if (!lastAddedItem) {
    return null;
  }

  const variantSuffix = lastAddedItem.variantLabel ? ` (${lastAddedItem.variantLabel})` : '';

  return (
    <div className="fixed bottom-4 left-4 z-50 w-full max-w-sm pointer-events-none">
      <div className="pointer-events-auto animate-slide-up">
        <Toast
          variant="success"
          title="Added to cart"
          description={`${lastAddedItem.quantity} x ${lastAddedItem.productName}${variantSuffix}`}
          duration={2400}
          onDismiss={clearAddFeedback}
        />
      </div>
    </div>
  );
}

export default CartFeedbackToast;
